import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { useCurrentUser } from '@shared/hooks';
import MainListItems from './MainListItems';

import './Dashboard.scss';

const DrawerMenu = ({ mobileOpen, onDrawerToggle, handleClose }) => {
  const user = useCurrentUser();
  const { change_password: changePassword } = user;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const drawer = (
    <Box className="drawer-menu-content" sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ flex: 1 }}>
        {!changePassword && <MainListItems icons={mobileOpen} isWeb={!isMobile} handleClose={handleClose} />}
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
      <Drawer
        variant={isMobile ? 'temporary' : 'permanent'}
        open={isMobile ? mobileOpen : true}
        onClose={isMobile ? onDrawerToggle : undefined}
        slotProps={{
          paper: {
            className: `drawer-menu-paper ${mobileOpen ? 'drawer-menu-paper-open' : 'drawer-menu-paper-collapsed'}`,
          },
        }}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}>
        {drawer}
      </Drawer>
    </Box>
  );
};

DrawerMenu.propTypes = {
  mobileOpen: PropTypes.bool.isRequired,
  onDrawerToggle: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default DrawerMenu;
